export enum BrowserTypeEnum {
  Unknown = 0,
  Galio = 1,
  SecondGen = 2,
  ThirdGen = 3
}